<template>
  <div>
    <a-upload :multiple="multiple" :action="uploadAction" :headers="headers" :data="{ biz: bizPath }"
      :fileList="fileList" :disabled="disabled" :beforeUpload="beforeUpload" @change="handleChange" @preview="preview"
      @download="preview">
      <slot>
        <!--<a-button icon="upload"> 点击上传</a-button>-->
      </slot>
    </a-upload>
    <div ref="viewer" class="images" v-viewer="viewerOptions" style="height: 1px">
      <img v-for="file in imageList" :src="file.url2" :key="file.url2" :alt="file.fileName" width="1px" height="1px" />
    </div>
  </div>

</template>

<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"
import { download, getFileName, getFileType, randomUUID } from "@/utils/util"
import { deleteAction } from '@/api/manage'
export default {
  name: 'JUpload',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    /*这个属性用于控制文件上传的业务路径*/
    bizPath: {
      type: String,
      required: false,
      default: "temp"
    },
    value: {
      type: Array,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    number: {
      type: Number,
      required: false,
      default: 9
    },
    type2: String,
    isShowType2: Boolean,
    isDownload: {
      type: Boolean,
      default: true
    },
    delfile: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      uploadAction: window._CONFIG['domianURL'] + "/sys/common/upload",
      uploadLoading: false,
      headers: {},
      fileList: [],
      imageList: [], // 筛选出图片文件
      viewerOptions: {}
    }
  },
  watch: {
    value: {
      handler(fileList) {
        if (!fileList || fileList.length === 0) {
          this.fileList = [];
          return;
        }
        if (Array.isArray(fileList) && fileList[0] && !fileList[0].uid) {
          this.initFileList(fileList)
        }
      },
      //立刻执行handler
      immediate: true
    }
  },
  created() {
    const token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = { "X-Access-Token": token }
    // 解决if渲染不触发watch问题
    const fileList = this.value || []
    if (Array.isArray(fileList) && fileList[0] && !fileList[0].uid) {
      this.initFileList(fileList)
    }
  },
  methods: {
    initFileList(files) {
      if (!files || files.length === 0) {
        this.fileList = [];
        return;
      }
      let fileList = [];
      files.forEach((file, index) => {
        fileList.push({
          uid: randomUUID(),
          name: file.name || getFileName(file.path),
          status: 'done',
          type2: 10,
          id: file.id,
          response: {
            success: true,
            status: "history",
            message: file.path
          }
        })
      })
      if (fileList.length > 0) {
        console.log('fileList------------', fileList)
        this.handleChange({ file: fileList[0], fileList , isInit: true})
      }
      // this.fileList = fileList
    },
    beforeUpload(file, fileList) {
      // console.log('beforeUpload', file, fileList)
      return true
    },
    /**
     * 上传回调 批量上传时每个文件都会触发该回调   上传中、完成、失败都会调用这个函数。
     * @param file
     * @param fileList
     */
    handleChange({ file, fileList, isInit = false }) {
      // console.log('handleChange-----', file, fileList)
      // 上传文件数量限制 ()
      if (!this.disabled && this.number > 0 && fileList.length > this.number) {
        this.$warning({ title: '提示', content: '已达到最大上传数量限制: ' + this.number })
        // fileList = fileList.slice(-this.number);
        fileList = fileList.slice(0, this.number);
      }
      if (file.status === 'done') {
        if (file.response.success) {
          fileList = fileList.map((file) => {
            if (file.response && file.response.message) {
              file.fileName = file.name
              file.url = file.name
              file.url2 = window._CONFIG['staticDomainURL'] + "/" + file.response.message

              const token = Vue.ls.get(ACCESS_TOKEN)
              if(file.url2 != "" && file.url2.indexOf("token")<0 && token){
                if(file.url2.indexOf("?")>=0){
                  file.url2 = file.url2 + "&token=" + token
                }else{
                  file.url2 = file.url2 + "?token=" + token
                }
              }  

              file.type2 = file.type2 || this.type2 || ''
              if (!file.hasOwnProperty('id')) {
                file.id = ''
              }
              // if (this.isShowType2 && !file.name.endsWith('）')) {
              //   file.name = file.name + `（${getDictItemText(['upload_type_1','upload_type_2'], file.type2)}）`
              // }
            }
            return file;
          });
          if (!isInit) {
            this.$message.info('上传成功!')
          }
        }else{
                this.$message.error(file.response.message)
              }
        // this.$message.success(`${file.name} 上传成功!`);
      } else if (file.status === 'uploading') {
      } else if (file.status === 'error') {
        this.$message.error(`${file.name} 上传失败.`);
      } else if (file.status === 'removed') {
        this.handleDelete(file)
      }
      this.fileList = fileList
      if (file.status === 'done' || file.status === 'removed') {     
        console.log('handlePathChange--');   
        this.handlePathChange()
      }
    },
    handlePathChange() {
      let uploadFiles = this.fileList
      let path = ''
      if (!uploadFiles || uploadFiles.length == 0) {
        path = ''
      }
      let arr = [];
      if (!this.multiple) {
        arr.push(uploadFiles[uploadFiles.length - 1].response.message)
      } else {
        for (let a = 0; a < uploadFiles.length; a++) {
          /*只处理上传成功的文件*/
          if (uploadFiles[a].status === 'done') {
            // arr.push(uploadFiles[a].response.message)
            arr.push((uploadFiles[a].fileName || uploadFiles[a].name) + '、' + uploadFiles[a].response.message + '、' + uploadFiles[a].type2)
          } else {
            return;
          }
        }
      }
      if (arr.length > 0) {
        path = arr.join(",")
      }
      this.$emit('change', uploadFiles);
      this.$emit('change2', path);
      // console.log('upload done change', path);
      // this.$emit('input', path);
    },
    handleDelete(file) {
      if (typeof this.delfile === 'function') {
        this.delfile(file.id);
      }else{
        //console.log('upload delete', file)
        deleteAction('/project/projectFile/delete', { id: file.id }).then(res => {
          if (res.success) {
            console.log('OK')
          }
        })
      }
    },
    handleCancel() {
      this.close();
    },
    close() {

    },
    preview(file) {
      if (!this.isDownload) {
        return
      }
      console.log('preview',this.isDownload, file)
      /*如果为图片,直接采用预览方式打开*/
      let fileType = getFileType(file.fileName)
      console.log("fileType---2"+fileType)
      if (fileType.includes('image')) {
        this.imageList = this.fileList.filter(f => {
          let ft = getFileType(f.fileName)
          if (ft.includes('image')) {
            return true
          }
        })
        const index = this.imageList.findIndex(img => img.url2 === file.url2)
        this.$refs.viewer.$viewer.show().view(index > -1 ? index : 0)
        return
      }
      download(file.url2, file.fileName)
    }
  },

}
</script>

<style scoped></style>
